import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const BtmTabs = styled.div`
  border-top: ${THEME.colors.tertiaryFontColor} 1px solid;

  ${Media.Below.mobileLarge`
    display: none;
  `}
`;

export const BtnOptionsCtn = styled.div`
  display: flex;
`;

export const BtnCtn = styled.div`
  width: 20%;
  min-width: 170px;
  margin: 0 15px;
`;

export const ContentCtn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  ${Media.Below.mobileLarge`
    flex-direction: row;
    flex-wrap: wrap;
  `}
`;

export const LogAJobBtn = styled.button`
  border: solid 1px ${THEME.colors.primaryColor};
  background-color: white;
  border-radius: 23px;
  height: 45px;
  width: 100%;
  margin-top: 4vh;
  cursor: pointer;

  > div {
    color: ${THEME.colors.primaryColor};
    font-size: 15px;
    font-weight: bold;

    ${Media.Below.desktop`
      white-space: nowrap;
      transform: rotate(-90deg);
    `}
  }

  ${Media.Below.desktop`
    display: flex;
    justify-content: center;
    margin-top: 0;
    height: 118px;
  `}

  ${Media.Below.mobileLarge`
    display: none;
  `}
`;

export const LogAJobBtnMobileCtn = styled.div`
  display: none;
  position: fixed;
  padding: 15px;
  width: 100%;
  bottom: 10px;
  z-index: 200;

  ${Media.Below.mobileLarge`
    display: initial;
  `}

  > div {
    display: flex;
    justify-content: center;
    background-color: white;
    border: ${THEME.colors.primaryColor} 1px solid;
    box-shadow: 0 3px 20px 0 rgba(0, 130, 189, 0.2);
    height: 7vh;
    max-height: 44px;
    width: 100%;
    cursor: pointer;

    > span {
      align-self: center;
      color: ${THEME.colors.primaryColor};
    }
  }
`;

export const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

interface FooterLogo {
  logo?: string;
  smallLogo?: string;
}

export const LogoCtn = styled.div<FooterLogo>`
  width: 90%;
  align-self: center;
  margin-top: auto;
  flex: 1 1 100%;
  height: 55px;
  min-height: 50px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;

  ${(props): SimpleInterpolation =>
    css`
      background-image: url(${props.logo});

      @media screen and (max-width: ${THEME.layout.tablet.breakpoint}px) {
        width: 90%;
        background-image: url(${props.smallLogo});
      }

      @media screen and (max-width: ${THEME.layout.mobileLarge.breakpoint}px) {
        background-image: url(${props.logo});
        height: 40px;
        min-height: 40px;
        margin-top: 0;
        width: unset;
        order: 2;
        flex: 1 1 50%;
      }
    `}
`;

export const NavCtn = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  position: fixed;
  top: 0;
  width: 240px;
  height: 100vh;
  padding: 25px 25px 10px;
  box-shadow: ${THEME.etc.primaryBorderShadow};
  overflow-y: auto;
  z-index: 80;

  /* width */
  &::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #c8cacb;
  }

  ${Media.Below.desktop`
    width: 70px;
    padding: 15px 14px;
    overflow-x: hidden;
  `}

  ${Media.Below.mobileLarge`
    flex-direction: row;
    width: 100%;
    height: 110px;
    padding: 10px 10px 0;
  `}
`;
interface NavDropdownProps {
  active?: boolean;
  init?: boolean;
}

export const NavdropDown = styled.div<NavDropdownProps>`
  position: fixed;
  top: 110px;
  width: 100%;
  padding: 13px 17px;
  z-index: 70;
  background-color: ${THEME.colors.primaryBackgroundColor};
  margin-bottom: 3vh;
  display: none;
  overflow: hidden;
  transition: max-height 1s ease-in-out;
  max-height: 0;

  ${(props): SimpleInterpolation =>
    props.active &&
    css`
      max-height: 50vh;
    `}

  ${Media.Below.mobileLarge`
    display: initial;
    padding: 0;
  `}
`;

export const NavdropDownDivider = styled.div`
  width: 100%;
  padding: 0 15px;
  background-color: ${THEME.colors.tertiaryFontColor};
  height: 1px;
`;

export const NavdropDownTab = styled.div`
  font-size: 12px;
  font-weight: bold;
  padding: 20px 30px 20px 0px;
  cursor: pointer;

  > span {
    margin-left: 15px;
  }
`;

export const TabsCtn = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 3vh;

  ${Media.Below.mobileLarge`
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    padding-bottom: 0;
    order: 3;
    flex: 1 1 100%;
  `}
`;
